<template>
  <!-- 列表 -->
  <div v-if="!isCreate">

    <!-- 任务列表 -->
    <baseBreadcrumb :page="$t('message.taskList')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="status" type="card" @tab-click="search">
          <el-tab-pane :label="item.name + (item.total != '' ? `(${item.total})` : '')" :name="index + ''"
            v-for="(item, index) in tabs" :key="index"></el-tab-pane>
        </el-tabs>
        <div class="create-button">
          <el-button v-if="isAuth(761)" type="success" @click="createTask">{{ $t('message.createTask') }}</el-button>
        </div>
      </div>
      <!-- 搜索项 -->
      <div class="search-form">
        <div class="search-row">
          <div class="item date-item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" v-model="createdTime" :default-time="['00:00:00', '23:59:59']"
              start-placeholder="任务生成日期起始" end-placeholder="任务生成日期结束" clearable>
            </el-date-picker>
          </div>
          <div class="item date-item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" v-model="executeTime" :default-time="['00:00:00', '23:59:59']"
              start-placeholder="任务完成日期起始" end-placeholder="任务完成日期结束" clearable>
            </el-date-picker>
          </div>
          <!-- 任务编号 -->
          <div class="item">
            <el-input v-model="datas.spot_sn" :placeholder="$t('message.taskNumber')"></el-input>
          </div>
          <!-- 执行人 -->
          <div class="item">
            <el-select v-model="datas.execute_by" :placeholder="$t('message.executor')" clearable filterable>
              <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 负责人 -->
          <div class="item">
            <el-select v-model="datas.liable_id" :placeholder="$t('message.personInCharge')" clearable filterable>
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="search-row">
          <!-- 订单配送单 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderDistribution')" clearable></el-input>
          </div>
          <!--任务类型  -->
          <div class="item">
            <el-select v-model="datas.type" :placeholder="$t('message.taskType')" clearable filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <!-- 人员层级 -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <!-- 订单类型 -->
          <div class="item">
            <el-select v-model="datas.order_type_id" :placeholder="$t('message.orderType')" clearable filterable>
              <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <!-- 业务员 -->
          <div class="item">
            <el-select v-model="datas.y_id" :placeholder="$t('message.salesman')" clearable filterable>
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" :placeholder="$t('message.distributionMember')" clearable filterable>
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="search-row">
          <!-- 触发条件 -->
          <div class="item">
            <el-select v-model="datas.trigger_condition" :placeholder="$t('message.triggerCondition')" clearable>
              <el-option v-for="item in triggerConditionList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--抽查结果  -->
          <div class="item">
            <el-select v-model="datas.execute_abnormal" :placeholder="$t('message.spotCheckResult')"
              clearable filterable>
              <el-option label="无异常" value="1">
              </el-option>
              <el-option label="有问题" value="2">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 基础信息 -->
          <li class="flex2">{{ $t('message.basicInformation') }}</li>
          <!-- 任务状态 -->
          <li>{{ $t('message.taskStatus') }}</li>
          <!-- 具体要求 -->
          <li class="flex3">{{ $t('message.specificRequirements') }}</li>
          <!-- : '抽查项目' -->
          <li class="flex3">{{ $t('message.spotCheckItems') }}</li>
          <!-- 备注 -->
          <li>{{ $t('message.remark') }}</li>
          <!-- 确认状态 -->
          <li>{{ $t('message.confirmStatus') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">
            {{ item.rowNumber }}
          </li>
          <!-- 基础信息 -->
          <li class="flex2">
            <div class="template">
              <p> 任务编号：{{ item.spot_sn }}</p>
              <p> 来源：{{ item.created_from }}</p>
              <p> 创建人：{{ item.created_by_admin ? item.created_by_admin.realname : '' }}</p>
              <p> 执行人：{{ item.execute_by_admin ? item.execute_by_admin.realname : '' }}</p>
              <p> 消息同步推送：<span v-for="name in item.msg_receive" :key=name.id>{{ name.realname }}、</span></p>
              <p> 生成日期：{{ item.created_at }}</p>
              <p> 截止时间：{{ item.end_at }} <el-button type="primary" size="mini" @click="edit_end_at(item)"
                  v-if="item.status == 10">编辑</el-button>
              </p>
            </div>
          </li>
          <!-- 任务状态 -->
          <li>
            <el-tag :type="setType(item.status, item.status_name)">{{ item.status_name }}</el-tag>
          </li>
          <!-- 具体要求 -->
          <li class="flex3">
            <div class="template">
              <p> 任务类型：{{ item.type_name }} </p>
              具体要求：<span v-for="(desc, descIndex) in item.desc" :key="descIndex">({{ descIndex + 1 }}){{ desc }},</span>
            </div>
          </li>
          <!-- : '抽查项目' -->
          <li class="flex3">
            <div class="template">
              <div class="item" v-for="(spot, spotIndex) in item.spot_detail" :key="spotIndex">
                <div class="type">
                  <div v-if="[1, 2, 3, 10].includes(item.type)">
                    <p>
                      <span style="margin-right: 20px;">对应：{{ item.order_y_admin ? item.order_y_admin.realname : ''
                      }}</span>
                      <span>跟进：{{ item.order_g_admin ? item.order_g_admin.realname : '' }}</span>
                    </p>
                    <p>
                      <router-link :to="'/orderPaymentDetail?order_sn=' + spot.order_sn" target="_blank" class="a-link">
                        {{ spot.order_sn }}-NO{{ spot.sorting }}
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[4, 5, 6].includes(item.type)">
                    <p>
                      <span style="margin-right: 20px;">对应：{{ item.porder_y_admin ? item.porder_y_admin.realname : ''
                      }}</span>
                      <span style="margin-right: 20px;">出货：{{ item.porder_g_admin ? item.porder_g_admin.realname : ''
                      }}</span>
                      <span>FBA：{{ item.porder_fba_admin ? item.porder_fba_admin.realname : '' }}</span>
                    </p>
                    <p>
                      <router-link :to="'/porderDetail?porder_sn=' + spot.porder_sn" target="_blank" class="a-link">
                        {{ spot.porder_sn }}
                      </router-link>
                    </p>
                    <p>
                      <router-link :to="'/orderPaymentDetail?order_sn=' + spot.order_sn" target="_blank" class="a-link">
                        {{ spot.order_sn }}-NO{{ spot.sorting }}
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[7].includes(item.type)">
                    <p>
                      <router-link :to="'/porderDetail?porder_sn=' + spot.porder_sn" target="_blank" class="a-link">
                        {{ spot.porder_sn }}-{{ spot.number }}箱
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[8].includes(item.type)">
                    <p> <router-link :to="'/porderDetail?porder_sn=' + spot.porder_sn" target="_blank" class="a-link">
                        {{ spot.porder_sn }}
                      </router-link></p>
                  </div>
                  <div v-if="[9].includes(item.type)">
                    <p>{{ spot.org_name }}</p>
                  </div>
                  <!-- 新增赔款 -->
                  <el-button type="success" v-if="spot.execute_abnormal == 2" @click="storeReparation(spot)">{{
                    $t('message.addCompensation')
                  }}</el-button>
                </div>
                <div class="status" v-if="spot.execute_abnormal">
                  <p> {{ $t('message.personInCharge') }}:{{ spot.liable_admin ?
                    spot.liable_admin.realname : '' }}</p>
                  <p>抽查结果：
                    <span style="color:#15AD3C" v-if="spot.execute_abnormal == 1">无异常</span>
                    <span style="color:#B4272D" v-if="spot.execute_abnormal == 2">有问题</span>
                  </p>
                  <p>
                    完成时间：{{ spot.deal_at }}
                  </p>
                </div>
                <div class="image" v-if="spot.image != null">
                  <div class="images">
                    <el-image v-for="(image, imageIndex) in spot.image" :key="imageIndex"
                      style="width: 40px; height: 40px;margin-right: 6px;" :src="image" :preview-src-list="[image]">
                    </el-image>
                  </div>
                  <!-- 查看全部 -->
                  <div class="viewAll">
                    <el-button type="primary" class="primary" @click="viewAll(spot)">{{ $t('message.viewAll')
                    }}</el-button>
                  </div>
                </div>
                <div class="video" v-if="spot.video != null">
                  <video v-for="(video, indexVideo) in spot.video" :key="indexVideo"
                    style="width: 140px; height: 80px;margin-right: 6px;" controls>
                    <source :src="video">
                  </video>
                </div>
                <div class="reparation">
                  <p v-for="(reparation, reparationIndex) in spot.spot_detail_reparation" :key="reparationIndex">
                    <router-link :to="'/reparationList?reparation_sn=' + reparation.reparation_sn" class="a-link"
                      target="_blank">
                      {{ reparation.reparation_sn }}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </li>
          <!-- 备注 -->
          <li>
            <el-input type="textarea" v-model="item.remark" @blur="updateRemark(item)"></el-input>
          </li>
          <!-- 确认状态 -->
          <li>{{ item.confirm_status_name }}</li>
          <!-- 操作 -->
          <li>
            <div class=" btn">
              <!-- 确认 -->
              <p v-if="item.confirm_status == 10">
                <el-button type="success" @click="spotConfirm(item.spot_sn)">{{ $t('message.notarize') }}</el-button>
              </p>
              <!-- 提醒执行人 关闭任务-->
              <div v-if="item.confirm_status == 0 && item.status != -1">
                <!-- 提醒执行人 -->
                <p>
                  <el-button v-if="isAuth(760)" type="success" class="primary" @click="remindExecutor(item.spot_sn)">{{
                    $t('message.remindExecutor') }}</el-button>
                </p>
                <!-- 关闭任务 -->
                <p>
                  <el-button v-if="isAuth(759)" type="primary" @click="spotCancel(item)">{{
                    $t('message.closeTask') }}</el-button>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 任务结果预览 -->
    <taskResultPreview ref="taskResultPreview" :itemData="itemData" />
    <!-- 关闭原因 -->
    <closeTask ref="closeTask" />
    <!-- 新增赔款单    -->
    <claimIndemnity ref="claimIndemnity" />
    <!-- 请选择任务类型 -->
    <el-dialog :title="$t('message.pleaseSelectTaskType')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="380px" center>
      <div class="row">
        <div class="label"><span>*</span>{{ $t('message.taskType') }}:</div>
        <div class="val"><el-select v-model="taskType" :placeholder="$t('message.taskType')" clearable filterable>
            <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="createTaskType">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
    <!--编辑截止时间  -->
    <el-dialog :title="$t('message.editTime')" :close-on-click-modal="false" :visible.sync="endDialogVisible"
      width="380px" center>
      <div class="row">

        <div class="val" style="margin: 0 auto;">
          <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            v-model="updateEndAtData.end_at" clearable>
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="updateEndAt">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="endDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>

  </div>
  <!-- 创建 -->
  <div v-else>
    <createTask ref="createTask" :taskType="taskType" :options="options" :adminList="adminList"
      :executeTypeList="executeTypeList" />
  </div>
</template>
<script>
import taskResultPreview from './components/taskResultPreview'
import closeTask from './components/closeTask'
import claimIndemnity from './components/claimIndemnity'
import createTask from './createTask/index'
export default {
  components: {
    taskResultPreview,
    closeTask,
    claimIndemnity,
    createTask
  },
  computed: {
    typeList() {
      return this.$store.state.typeList;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    triggerConditionList() {
      return [
        { value: 'high_amount', label: this.$t('message.highAmountTrigger') },
        { value: 'after_sale', label: this.$t('message.afterSaleHistoryTrigger') },
        { value: 'oem', label: this.$t('message.oemTrigger') },
        { value: 'manual', label: this.$t('message.manualGenerationTrigger') },
      ];
    },
  },
  data() {
    return {
      status: '',
      tabs: [],//列表tab统计
      options: [], //分类枚举
      executeTypeList: [],//执行人类型枚举
      adminList: [],// 责任人
      createdTime: [],
      executeTime: [],
      datas: {
        page: 1,
        pageSize: 20,
        org_id: '',
        order_type_id: '',
        y_id: '',
        p_id: '',
        trigger_condition: '',
      },
      tableData: [],
      total: 0,
      itemData: {},
      reparation_sn: '',
      spot_detail_id: 0,
      // 创建任务
      isCreate: false,
      dialogVisible: false,
      taskType: '',
      // 编辑截止时间
      updateEndAtData: {
        spot_sn: '',
        end_at: '',
      },
      endDialogVisible: false,
    };
  },
  created() {
    if(this.$route.query.spot_sn) {
      this.datas.spot_sn = this.$route.query.spot_sn
    }
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    // 分类枚举
    this.$api.spotCheckApi.spotTypeList().then(res => {
      this.options = res.data
    })
    // 执行人
    this.$api.spotCheckApi.executeTypeList().then(res => {
      this.executeTypeList = res.data
    })
    this.listTab()

    this.spotList()
  },
  methods: {
    // 列表tab统计
    listTab() {
      this.$api.spotCheckApi.listTab().then(res => {
        this.tabs = res.data

        this.tabs.unshift({
          name: "全部",
          total: ''
        })
      })
    },
    spotList() {
      // 优化时间参数处理
      const setTimeParams = (source, targetStart, targetEnd) => {
        if (source) {
          this.datas[targetStart] = source[0];
          this.datas[targetEnd] = source[1];
        } else {
          this.datas[targetStart] = '';
          this.datas[targetEnd] = '';
        }
      };
      // 处理时间参数
      setTimeParams(this.createdTime, 'created_at_start', 'created_at_end');
      setTimeParams(this.executeTime, 'execute_at_start', 'execute_at_end');
      // 发起请求
      this.$api.spotCheckApi.spotList(this.datas).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search(e) {
      if (e) {
        this.datas.status = ''
        this.datas.confirm_status = ''
        this.datas.is_over_time = ''
        if (e.index == 3) {
          this.datas.is_over_time = 1
        } else if (e.index < 5 && e.index > 0) {
          this.datas.status = this.tabs[e.index].filter_value
        } else if (e.index >= 5) {
          this.datas.confirm_status = this.tabs[e.index].filter_value
        }
        this.listTab();
      }
      this.datas.page = 1;
      this.spotList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        status: "",
        confirm_status: "",
        is_over_time: "",
        created_at_start: '',
        created_at_end: '',
        execute_at_start: '',
        execute_at_end: '',
        liable_id: '',
        type: '',
        execute_abnormal: '',
        spot_sn: '',
        execute_by: '',
        order_sn: '',
        org_id: '',
        order_type_id: '',
        y_id: '',
        p_id: '',
        trigger_condition: '',
      };
      this.createdTime = []
      this.executeTime = []
      this.$refs.cascader.orgId = []
      this.spotList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.spotList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.spotList();
    },
    // 人员层级
    setUserList(data) {
      this.datas.org_id = data.id;
    },
    //标签类型
    setType(status, status_name) {
      if (status == -1) {
        return 'info'
      } else if (status == 20) {
        return 'success'
      } else if (status == 1) {
        return 'danger'
      } else if (status == 10 && status_name == '待执行') {
        return 'warning'
      }

    },
    //查看全部
    viewAll(item) {
      this.itemData = item
      this.$refs.taskResultPreview.dialogVisible = true
    },
    //关闭任务
    spotCancel(item) {
      this.$refs.closeTask.datas = {
        spot_sn: item.spot_sn,
        cancel_reason: '',
      }
      this.$refs.closeTask.dialogVisible = true
    },
    //确认任务
    spotConfirm(spot_sn) {
      this.$confirm('该任务是否完成？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        // 发起请求
        this.$api.spotCheckApi.spotConfirm({ spot_sn }).then(res => {
          this.$message.success(res.msg)
          this.spotList()
        });
      }).catch(() => {
      });
    },
    // 提醒执行人
    remindExecutor(spot_sn) {
      this.$api.spotCheckApi.resendNotice({ spot_sn }).then(res => {
        this.$confirm('消息发送成功', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          // 发起请求

        }).catch(() => {
        });
      });

    },
    //新增赔款
    storeReparation(spot) {
      let obj = {
        spot_detail_id: spot.id,
        reparation_sn: '',
        image: spot.image
      }
      this.$api.capitalApi.getNewReparationSn().then(res => {
        obj.reparation_sn = res.data
        this.$refs.claimIndemnity.addIndemnity(obj)
      })
    },
    //创建任务
    createTask() {
      this.taskType = ''
      this.dialogVisible = true
    },
    //创建任务类型
    createTaskType() {
      if (this.taskType == '') return this.$message.error('请选择任务类型')
      this.isCreate = true
      this.dialogVisible = false
    },
    // 编辑备注
    updateRemark(item) {
      let datas = {
        spot_sn: item.spot_sn,
        remark: item.remark,
      }
      this.$api.spotCheckApi.updateRemark(datas)
    },
    // 修改时间
    edit_end_at(item) {
      this.updateEndAtData = {
        spot_sn: item.spot_sn,
        end_at: item.end_at,
      }
      this.endDialogVisible = true
    },
    // 修改结束时间
    updateEndAt() {
      // 发起请求
      this.$api.spotCheckApi.updateEndAt(this.updateEndAtData).then(res => {
        this.$message.success(res.msg)
        this.spotList()
        this.endDialogVisible = false
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.search-form {
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .item {
    flex: 0 0 217px;

    /deep/ .el-input,
    /deep/ .el-select,
    /deep/ .el-date-editor {
      width: 100%;
    }
  }

  .date-item {
    flex-basis: 400px;
  }
}

.tabs {
  position: relative;

  .create-button {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  position: relative;

  ol {
    height: 50px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

  }

  ul {
    padding: 20px 0;
    background-color: #fff;

    /deep/.el-textarea__inner {
      height: 150px !important;
      resize: none;
      padding: 5px;
    }
  }

  .flex05 {
    flex: 0.5;

  }

  .flex2 {
    flex: 2;
  }

  .flex3 {
    flex: 3;
  }

  .template {
    width: 100%;

    p {
      line-height: 22px;
    }

    .item {
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 4px;
      margin-bottom: 10px;

      .type {
        position: relative;
        font-weight: 600;

        .el-button {
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .status {
        margin: 10px 0;
      }

      .image {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .images {
          flex: 1;
          overflow: hidden;
        }

        .viewAll {
          position: relative;

          .el-image {
            width: 100px;
            height: 40px;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
          }
        }
      }

      &:nth-last-child(1) {
        margin: 0;
      }


    }
  }

  .btn {
    p {
      margin-bottom: 12px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .el-button {
      width: 110px !important;
    }
  }
}

.row {
  display: flex;
  padding: 0 10px;

  .label {
    margin-right: 10px;
    line-height: 40px;

    span {
      color: red;
      margin-right: 5px;
    }
  }
}
</style>
